import { type UseQueryResult, useQuery } from 'react-query';
import {
  DisbursementSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto,
} from '../../services/wealthlane-award-settlement-services';

const useGetDisbursementDetailForBrokerTradeTool = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  transactionId: string,
  companyId?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementDetailDto | undefined,
  unknown
> => {
  return useQuery(
    ['getDisbursementDetailForBrokerTradeTool', transactionId, companyId],
    async () => {
      if (transactionId) {
        return await handleRequest(
          DisbursementSharedService.getApiAwardSettlementApiAppDisbursementDisbursementDetailForBrokerTradeTool(
            transactionId,
            companyId
          )
        );
      }
    },
    {
      enabled: !!transactionId,
    }
  );
};

export default useGetDisbursementDetailForBrokerTradeTool;
